// actions/notificationActions.js
import {
  FETCH_NOTIFICATIONS_REQUEST,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_FAILURE,
  MARK_NOTIFICATION_READ_REQUEST,
  MARK_NOTIFICATION_READ_SUCCESS,
  MARK_NOTIFICATION_READ_FAILURE,
  MARK_ALL_NOTIFICATIONS_READ_REQUEST,
  MARK_ALL_NOTIFICATIONS_READ_SUCCESS,
  MARK_ALL_NOTIFICATIONS_READ_FAILURE,
  DELETE_NOTIFICATION_REQUEST,
  DELETE_NOTIFICATION_SUCCESS,
  DELETE_NOTIFICATION_FAILURE,
  GET_NOTIFICATION_STATS_REQUEST,
  GET_NOTIFICATION_STATS_SUCCESS,
  GET_NOTIFICATION_STATS_FAILURE,
  ADD_NEW_NOTIFICATION,
  UPDATE_NOTIFICATION_COUNT,
} from "./notificationActionTypes";


// Fetch Notifications
export const fetchNotificationsRequest = () => ({ 
  type: FETCH_NOTIFICATIONS_REQUEST 
});

export const fetchNotificationsSuccess = (data) => ({
  type: FETCH_NOTIFICATIONS_SUCCESS,
  payload: { 
    data: {
      notifications: data.notifications,
      currentPage: data.currentPage,
      totalPages: data.totalPages,
      totalCount: data.totalCount,
      unreadCount: data.unreadCount,
    },
    type: "notificationsData" 
  },
});

export const fetchNotificationsFailure = (error) => ({
  type: FETCH_NOTIFICATIONS_FAILURE,
  payload: error,
});

// Mark Notification as Read
export const markNotificationReadRequest = () => ({ 
  type: MARK_NOTIFICATION_READ_REQUEST 
});

export const markNotificationReadSuccess = (data) => ({
  type: MARK_NOTIFICATION_READ_SUCCESS,
  payload: { 
    data: {
      notification: data.notification
    },
    type: "notificationRead" 
  },
});

export const markNotificationReadFailure = (error) => ({
  type: MARK_NOTIFICATION_READ_FAILURE,
  payload: error,
});

// Mark All Notifications as Read
export const markAllNotificationsReadRequest = () => ({ 
  type: MARK_ALL_NOTIFICATIONS_READ_REQUEST 
});

export const markAllNotificationsReadSuccess = (data) => ({
  type: MARK_ALL_NOTIFICATIONS_READ_SUCCESS,
  payload: { data, type: "allNotificationsRead" },
});

export const markAllNotificationsReadFailure = (error) => ({
  type: MARK_ALL_NOTIFICATIONS_READ_FAILURE,
  payload: error,
});

// Delete Notification
export const deleteNotificationRequest = () => ({ 
  type: DELETE_NOTIFICATION_REQUEST 
});

export const deleteNotificationSuccess = (data) => ({
  type: DELETE_NOTIFICATION_SUCCESS,
  payload: { data, type: "notificationDeleted" },
});

export const deleteNotificationFailure = (error) => ({
  type: DELETE_NOTIFICATION_FAILURE,
  payload: error,
});

// Get Notification Stats
export const getNotificationStatsRequest = () => ({ 
  type: GET_NOTIFICATION_STATS_REQUEST 
});

export const getNotificationStatsSuccess = (data) => ({
  type: GET_NOTIFICATION_STATS_SUCCESS,
  payload: { data, type: "notificationStats" },
});

export const getNotificationStatsFailure = (error) => ({
  type: GET_NOTIFICATION_STATS_FAILURE,
  payload: error,
});

// Real-time notifications
export const addNewNotification = (notification) => ({
  type: ADD_NEW_NOTIFICATION,
  payload: notification,
});

export const updateNotificationCount = (count) => ({
  type: UPDATE_NOTIFICATION_COUNT,
  payload: count,
});